/**
 * @file API 設定檔
 * @description 定義 API 相關的設定，包括基礎 URL 和請求超時時間
 */

export const API_CONFIG = {
    DEV_BASE_URL: 'http://localhost:8000/api',
    DEFAULT_TIMEOUT: 10000,  // 預設 10 秒
    LONG_TIMEOUT: 120000,    // 長時間請求 2 分鐘
};